(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('VisioneConsenso', VisioneConsenso);

    VisioneConsenso.$inject = ['$resource', 'DateUtils'];

    function VisioneConsenso ($resource, DateUtils) {
        var resourceUrl =  'api/visione-consensos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataVisione = DateUtils.convertDateTimeFromServer(data.dataVisione);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
